module.exports = __webpack_public_path__ + "static/media/Veterans.c5cf7bfa.svg";